import lazyLoad from './lazyLoad';

function getYoutubeThumbnail(videoId, type) {
    switch (type) {
        case 'jpg':
            return 'https://i.ytimg.com/vi/' + videoId + '/sddefault.jpg';
        case 'webp':
        default:
            return 'https://i.ytimg.com/vi_webp/' + videoId + '/sddefault.webp';
    }
}

let $embed = $('<iframe class=\'youtube-player\' type=\'text/html\' src=\'\' frameborder=\'0\' allowfullscreen allow=\'autoplay\'></iframe>');
function initYoutubeVid(item) {
    let $item = $(item);
    let vidId = $item.attr('data-vid-id');
    $item.css('background-image', 'url(' + getYoutubeThumbnail(vidId, 'webp') + ')');
    $item.css('background-size', 'contain');
    if ($item.attr('data-thumbnail-only') == 'true') {
        return;
    }
    let onclickDest = $item.attr('data-onclick-destination');
    if (onclickDest) {
        $item.on('click', function() {
            window.open(onclickDest);
        });
        return;
    }
    $item.on('click', function() {
        let $this = $(this);
        if ($item.find('iframe').length) {
            return;
        }
        let newTab = $this.attr('data-newtab');
        if (newTab == 'true') {
            window.open('https://www.youtube.com/watch?v=' + $this.attr('data-vid-id'));
            return;
        }
        $this.find('.play-button').remove();
        let $temp = $embed.clone();
        $temp.attr('width', $this.attr('data-width'));
        $temp.attr('height', $this.attr('data-height'));
        $temp.attr('src', 'https://www.youtube.com/embed/' + $this.attr('data-vid-id') + '?autoplay=1&enablejsapi=1');
        $this.append($temp);
    });
}

function initYoutubeVidLazy(item) {
    let observer = lazyLoad.createGeneralIntersectionObserver(function() {
        initYoutubeVid(item);
    });
    if (observer) {
        observer.observe(item);
    } else {
        initYoutubeVid(item);
    }
}

function initAll() {
    $(function() {
        let $wrappers = $('.youtube-wrapper');
        if ($wrappers.length) {
            $wrappers.each(function (_index, item) {
                initYoutubeVidLazy(item);
            });
        }
    });
}

export default {
    getYoutubeThumbnail,
    initYoutubeVid,
    initYoutubeVidLazy,
    initAll
};